(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9275);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _General_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8472);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);



function EnquiryResponseSuccess(param) {
    let { show , onClose  } = param;
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_General_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        show: show,
        styles: "w-[80%] lg:w-1/4",
        transition: "animateup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "content pt-4 pb-10 px-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        onClick: onClose,
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 1.5,
                        stroke: "currentColor",
                        className: "w-6 h-6 cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M6 18L18 6M6 6l12 12"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/Layout/EnquirySuccess.png",
                        width: 200,
                        height: 200,
                        alt: "Success",
                        className: "pt-3 pb-6"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "content text-center px-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "pt-2 text-theme-black font-light",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-theme-orange font-semibold",
                                children: "Thank you "
                            }),
                            "You have submitted your response successfully! \uD83C\uDF89"
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EnquiryResponseSuccess);


/***/ }),

/***/ 9310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _General_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(348);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5444);
/* harmony import */ var _General_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3607);
/* harmony import */ var _Layout_EnquiryForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7625);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9473);
/* harmony import */ var _store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1266);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2175);
/* harmony import */ var _Layout_EnquirySuccess__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6113);
/* harmony import */ var _General_TextArea__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6965);
/* harmony import */ var _validations_Enquiry__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6578);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	border-radius : 4px;\n	width : 35px;\n	height : 35px;\n	background : transparent;\n	color : #384C9A;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}













const StyledQuantitySuffix = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ea94def6-0"
})(_templateObject());
function ShortEnquiry(param) {
    let { firstHeading , secondHeading , subText  } = param;
    let initialValues = {
        // Autocomplete fields
        product_string: "",
        // Main fields
        product: null,
        product_text: "",
        quantity: null,
        unit: 1,
        message: "",
        // selected fields
        expected_certificates: [],
        pharmacopoeia_grades: []
    };
    const [showProductResults, setShowProductResults] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const [productString, setProductString] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
    const [casNumber, setCasNumber] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("");
    const [showEnquiryModal, setShowEnquiryModal] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    const { values , errors , touched , handleBlur , handleChange , handleSubmit , resetForm , setFieldValue  } = (0,formik__WEBPACK_IMPORTED_MODULE_8__/* .useFormik */ .TA)({
        initialValues: initialValues,
        validationSchema: _validations_Enquiry__WEBPACK_IMPORTED_MODULE_11__/* .ShortEnquiryFormSchema */ .kA,
        onSubmit: (values)=>{
            const payload = {
                ...values
            };
            payload["attachment"] = files.length ? files[0].id : null;
            // In case a Product String is there but not selected any predefined product.
            if (payload.product_string !== "" && payload.product === null) {
                payload.product_text = payload.product_string;
                setFieldValue("product_text", payload.product_string);
            }
            if (user.isLoggedIn) {
                dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .submitEnquiry */ .yW)(payload));
            } else {
                dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .openEnquiryModal */ .Qy)(payload));
                setShowEnquiryModal(true);
            }
        }
    });
    const { apiList , countryList , enquiryState , files  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)((state)=>state.core);
    const { user  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)((state)=>state.auth);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(()=>{
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getCertificateList */ .DC)());
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getPharmacopoeiaGrades */ .z8)());
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(()=>{
        if (enquiryState.showSuccessModal) {
            resetEnquiryForm();
        }
    }, [
        enquiryState.showSuccessModal
    ]);
    // FUNCTIONS
    const handleProductSearch = (event)=>{
        setProductString(()=>event.target.value);
        setFieldValue("product_string", event.target.value);
        setShowProductResults(true);
        const params = {
            page: 1,
            page_size: 5,
            search: event.target.value
        };
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .getAPIList */ .u8)(params));
        if (event.target.value == "") {
            setFieldValue("product", null);
        }
    };
    const selectProduct = (data)=>{
        setProductString(()=>data.name);
        setCasNumber(()=>data.cas_number);
        setFieldValue("product_string", data.name);
        setFieldValue("product", data.id);
        setShowProductResults(false);
    };
    const handleProductClear = ()=>{
        setProductString(()=>"");
        setFieldValue("product_string", "");
        setFieldValue("product", null);
        setCasNumber(()=>"");
    };
    const resetEnquiryForm = ()=>{
        resetForm();
        setProductString("");
        dispatch((0,_store_CoreSlice__WEBPACK_IMPORTED_MODULE_6__/* .setFileData */ .$C)({
            data: [],
            action: "replace"
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                id: "enquiry-section",
                className: "pb-10 min-h-[300px] relative lg:flex justify-between items-center --align overflow-x-hidden py-[40px] lg:py-[70px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        className: "hidden md:inline-block absolute top-[80px] -left-[60px] z-0",
                        src: "/Home/Ellipse.svg",
                        width: 300,
                        height: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        className: "hidden md:inline-block absolute bottom-[100px] -right-[100px] -z-9",
                        src: "/Home/Ellipse.svg",
                        width: 300,
                        height: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "text-theme-dark-saffron text-left mb-8 lg:w-[40%] relative",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                className: "text-3xl font-semibold -mb-4 lg:-mb-0 md:text-2xl lg:text-[2.9rem]",
                                children: [
                                    " ",
                                    firstHeading,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                                className: "text-3xl font-semibold pt-5 md:text-2xl lg:text-[2.9rem] mb-3",
                                children: [
                                    " ",
                                    secondHeading,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h2", {
                                className: "text-sm lg:text-xl text-theme-blue",
                                children: [
                                    " ",
                                    subText,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "text-sm lg:text-lg mt-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex mb-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/Home/Call.svg",
                                                alt: "",
                                                className: "w-[29px] h-[29px] mr-[9px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-theme-dark-saffron",
                                                children: "+91-8655735634"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/Home/Email.svg",
                                                alt: "",
                                                className: "w-[29px] h-[29px] mr-[9px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-theme-dark-saffron",
                                                children: "support@apidrug.com"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                        id: "enquiry-form",
                        onSubmit: handleSubmit,
                        className: "\n                                relative \n                                z-1 \n                                bg-[#FEF7F5] \n                                grid \n                                grid-cols-1 \n								rounded-[5px]\n                                gap-4 \n                                md:grid-cols-2 \n                                lg:grid-cols-4\n                                gap-y-4\n								p-5\n                                lg:p-[30px]\n                                lg:w-[70%]\n                            ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "lg:col-span-2 relative",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        label: "Product",
                                        labelColor: "#305399",
                                        placeholder: "eg. Paracetamol",
                                        search: true,
                                        name: "product_string",
                                        onInput: handleProductSearch,
                                        value: productString,
                                        background: "#FEF7F5",
                                        color: "#314783",
                                        outerProperties: "rounded ".concat(!productString && "py-[11.5px]", " border border-[#0000001a]"),
                                        error: errors.product_string,
                                        touched: touched.product_string,
                                        onBlur: (e)=>{
                                            setTimeout(()=>{
                                                setShowProductResults(()=>false);
                                                handleBlur(e);
                                            }, 300);
                                        },
                                        searchResults: showProductResults && apiList.list.map((data, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                                onClick: ()=>selectProduct(data),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                    className: "flex flex-col font-light",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                            children: [
                                                                data.name,
                                                                " (",
                                                                data.cas_number,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                                                            children: [
                                                                " ",
                                                                data.product_type,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index)),
                                        suffix: productString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            onClick: handleProductClear,
                                            className: "cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-6 h-6",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M6 18L18 6M6 6l12 12"
                                                })
                                            })
                                        })
                                    }),
                                    casNumber ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small", {
                                        className: "text-[#9ca3af] inline-block mt-2 opacity-70",
                                        children: [
                                            " CAS # ",
                                            casNumber,
                                            " "
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                        className: "text-[#9ca3af] inline-block mt-2 opacity-70",
                                        children: " CAS # will be auto populated "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "w-full ml-auto lg:col-span-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_General_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "mb-3",
                                    label: "Quantity",
                                    labelColor: "#305399",
                                    placeholder: "eg. 10",
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    outerProperties: "rounded py-0.5 border border-[#0000001a]",
                                    suffix: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledQuantitySuffix, {
                                        className: "text-white bg-theme-blue m-1 text-sm flex justify-center items-center",
                                        children: "KG"
                                    }),
                                    onChange: handleChange,
                                    name: "quantity",
                                    value: values.quantity,
                                    onBlur: handleBlur,
                                    error: errors.quantity,
                                    touched: touched.quantity
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "col-span-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_General_TextArea__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    outerProperties: "w-full mt-3 pt-3 rounded placeholder:text-sm placeholder:font-light border border-[#0000001a]",
                                    rows: 4,
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    placeholder: "Add your required target price, make, quality certificates, delivery date, delivery country etc..",
                                    onChange: handleChange,
                                    name: "message",
                                    value: values.message,
                                    onBlur: handleBlur,
                                    error: errors.message,
                                    touched: touched.message
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_General_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                styles: "w-full text-white bg-theme-orange h-12 lg:w-[150px]",
                                destinationEvent: "",
                                children: "Submit"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_EnquiryForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                show: showEnquiryModal,
                data: values,
                payload: values,
                countryList: countryList.fixedList,
                onClose: ()=>setShowEnquiryModal(false)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_EnquirySuccess__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                show: enquiryState.showSuccessModal,
                user: enquiryState.responseData ? enquiryState.responseData.user : ""
            })
        ]
    });
}
ShortEnquiry.defaultProps = {
    firstHeading: "Didn't find what",
    secondHeading: "you're looking for?",
    subText: "Share your requirement with us and we will find the best deal for you"
};
/* harmony default export */ __webpack_exports__["Z"] = (ShortEnquiry);


/***/ }),

/***/ 2868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function Title(param) {
    let { title  } = param;
    const Title = "".concat(title, " | APIdrug Platform");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: Title
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Title);


/***/ }),

/***/ 9275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/styles/Home/Home.module.css
var Home_module = __webpack_require__(8183);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/styles/Home/hero-section.module.css
var hero_section_module = __webpack_require__(4621);
var hero_section_module_default = /*#__PURE__*/__webpack_require__.n(hero_section_module);
// EXTERNAL MODULE: ./src/components/General/Button.tsx
var Button = __webpack_require__(3607);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/AuthSlice.js
var AuthSlice = __webpack_require__(5102);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@szhsin/react-menu/dist/index.css
var dist = __webpack_require__(112);
// EXTERNAL MODULE: ./node_modules/@szhsin/react-menu/dist/transitions/slide.css
var slide = __webpack_require__(16);
// EXTERNAL MODULE: ./src/utils/helpers.ts + 2 modules
var helpers = __webpack_require__(4143);
// EXTERNAL MODULE: ./src/components/ProductSearch.tsx
var ProductSearch = __webpack_require__(6664);
// EXTERNAL MODULE: ./src/components/Layout/ProfileMenu.tsx + 26 modules
var ProfileMenu = __webpack_require__(8249);
// EXTERNAL MODULE: ./src/components/Layout/ProfileDrawer.tsx
var ProfileDrawer = __webpack_require__(8237);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/components/WhatsappButton.tsx + 1 modules
var WhatsappButton = __webpack_require__(9299);
// EXTERNAL MODULE: ./src/components/General/Input.tsx
var Input = __webpack_require__(348);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(4231);
// EXTERNAL MODULE: ./src/MixPanel.ts
var MixPanel = __webpack_require__(5067);
// EXTERNAL MODULE: ./src/store/ToastSlice.js
var ToastSlice = __webpack_require__(6497);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(2175);
;// CONCATENATED MODULE: ./src/components/Home/hero-section.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color : #D8D8D8;\n	border-left : 1px solid #D8D8D8;\n	padding : 0 15px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	&::after {\n		content : '';\n		display: block;\n        width: 30%;\n        margin: 10px auto 0 auto;\n        background-color: #EC6303;\n        height: 3px;\n	}\n\n	&:hover::after {\n		width : 100%;\n		transition : 0.6s;\n	}\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}





















const StyledMic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5bcf0b-0"
})(_templateObject());
const AnimatedBorderDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c5bcf0b-1"
})(_templateObject1());
function HeroSection() {
    const router = (0,next_router.useRouter)();
    const { apiList: { list  }  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    const [showDrawer, setShowDrawer] = (0,react.useState)(false);
    // FUNCTIONS
    // Handle Auth Modal
    const openDialog = function() {
        let ID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        dispatch((0,AuthSlice/* handleAuthModal */.eD)(true));
    // if(ID) 
    //     dispatch(setRedirectTo(`deals/${ID}`));
    };
    const initialValues = {
        phone: ""
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const { values , errors , handleSubmit , handleBlur , handleChange , touched  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: yup_es/* object */.Ry({
            phone: yup_es/* number */.Rx().required("This field is required!").nullable().typeError("Please enter a valid phone number!")
        }),
        onSubmit: (values, action)=>{
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().toWhatsAppChat({
                phone: values.phone
            });
            action.resetForm();
            dispatch((0,ToastSlice/* setSnackBar */.c6)({
                color: "success",
                message: "Thank you for providing the details!"
            }));
            window.open("https://api.whatsapp.com/send?phone=918655735634", "_blank");
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((hero_section_module_default()).heroContainer),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header flex justify-between items-center py-[20px] lg:py-[20px] --align",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "lg:w-[197px] lg:h-[48px]",
                                src: "/Logo.svg",
                                alt: "logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-x-8 text-theme-black font-[400]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            className: "hidden lg:inline-block",
                                            href: "/spot-buying",
                                            children: "Spot Buying"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "hidden lg:inline-block cursor-pointer",
                                            onClick: ()=>router.pathname === "/products/[slug]" ? helpers/* default.scrollTo */.Z.scrollTo("get-in-touch", 140) : helpers/* default.scrollTo */.Z.scrollTo("enquiry-section", 140),
                                            children: "Bulk Deals"
                                        }),
                                        !user.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatedBorderDiv, {
                                            className: "hidden text-[16px] text-theme-black mr-[50px] cursor-pointer md:block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "http://seller.apidrug.com/",
                                                target: "_blank",
                                                children: "Sell on API Drug"
                                            })
                                        })
                                    ]
                                }),
                                user.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center ".concat((hero_section_module_default()).burger),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                onClick: ()=>setShowDrawer(true),
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-8 h-8 cursor-pointer text-[#444444]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center ml-8 ".concat((hero_section_module_default()).getInTouch),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu/* default */.Z, {
                                                    buttonColor: "#444444"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    onClick: ()=>helpers/* default.scrollTo */.Z.scrollTo("enquiry-section", 140),
                                                    styles: "bg-theme-orange text-white ml-7 lg:w-[180px] lg:h-[50px] text-[16px]",
                                                    destinationEvent: "Scrolled To Footer",
                                                    children: "Get In Touch"
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "button flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: openDialog,
                                        styles: "bg-theme-orange text-sm lg:text-base text-white font-[400] w-[130px] h-[40px] lg:w-[180px] lg:h-[50px] text-[16px]",
                                        children: "Login / Register"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((hero_section_module_default()).backgroundContainer, " flex flex-col justify-center --align lg:flex-row lg:justify-between lg:items-center lg:mt-[40px]"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-[#294788] text-[40px] font-[600] lg:text-[66px]",
                                    children: "Buy Any API,"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-[#294788] text-[40px] font-[600] lg:text-[66px] lg:-mt-[15px]",
                                    children: "Anytime, At The"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-[#294788] text-[40px] font-[600] lg:text-[66px] lg:-mt-[15px]",
                                    children: "Best Price"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappButton/* default */.Z, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "hidden lg:inline-block w-[511px] h-[274px]",
                            src: "/Home/HeroSectionImage.png",
                            alt: "hero_image"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "--align mt-[30px] lg:w-[50%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "md:flex md:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:w-[60%]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    outerProperties: "rounded border-[rgba(0, 0, 0, 0.10)] bg-[#F5F5F5] pl-[10px]",
                                    properties: "rounded h-[51.9px] placeholder:text-[15px] placeholder:font-[400]",
                                    name: "phone",
                                    value: values.phone,
                                    onBlur: handleBlur,
                                    error: errors.phone,
                                    touched: touched.phone,
                                    onChange: handleChange,
                                    background: "#F5F5F5",
                                    placeholder: "Enter Your Phone Number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                type: "submit",
                                destinationEvent: "External Redirection to WhatsApp | From hero section",
                                styles: "flex bg-theme-orange rounded-[5px] w-full h-[52px] mt-[10px] text-[#393F46] md:mt-0 md:w-[200px] md:ml-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "w-[24px] mr-[10px]",
                                        src: "/WhatsAppIcon.svg",
                                        alt: "WA"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[18px] font-[500] text-white",
                                        children: " Get Best Quote "
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "--align mt-[30px] lg:mt-[70px] lg:w-[87%] lg:mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSearch/* default */.Z, {
                        shadow: true,
                        searchIconHeight: "w-[25px] lg:w-[40px]"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[20px] lg:mt-[40px] --align flex flex-wrap justify-between items-center gap-y-[20px] md:justify-center md:gap-x-[20px] lg:gap-x-[96px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "mr-2",
                                    src: "/Home/TickCircle.svg",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] text-[#294788e6] font-[600]",
                                    children: "Free To Use"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "mr-2",
                                    src: "/Home/TickCircle.svg",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] text-[#294788e6] font-[600]",
                                    children: "5000+ Suppliers"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "mr-2",
                                    src: "/Home/TickCircle.svg",
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[16px] text-[#294788e6] font-[600]",
                                    children: "500+ shipments/month"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDrawer/* default */.Z, {
                    show: showDrawer,
                    onClose: ()=>setShowDrawer(false)
                })
            ]
        })
    });
}
/* harmony default export */ var hero_section = (HeroSection);

// EXTERNAL MODULE: ./src/components/Home/FAQs.tsx + 2 modules
var FAQs = __webpack_require__(8164);
;// CONCATENATED MODULE: ./src/hooks/useScrollDirection.ts

const THRESHOLD = 0;
const useScrollDirection = ()=>{
    const [scrollDirection, setScrollDirection] = (0,react.useState)("up");
    const blocking = (0,react.useRef)(false);
    const prevScrollY = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        prevScrollY.current = window.pageYOffset;
        const updateScrollDirection = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - prevScrollY.current) >= THRESHOLD) {
                const newScrollDirection = scrollY > prevScrollY.current ? "down" : "up";
                setScrollDirection(newScrollDirection);
                prevScrollY.current = scrollY > 0 ? scrollY : 0;
            }
            blocking.current = false;
        };
        const onScroll = ()=>{
            if (!blocking.current) {
                blocking.current = true;
                window.requestAnimationFrame(updateScrollDirection);
            }
        };
        window.addEventListener("scroll", onScroll);
        return ()=>window.removeEventListener("scroll", onScroll);
    }, [
        scrollDirection
    ]);
    return scrollDirection;
};


// EXTERNAL MODULE: ./src/components/General/Select.tsx + 47 modules
var Select = __webpack_require__(7418);
// EXTERNAL MODULE: ./src/components/Layout/EnquiryForm.tsx
var EnquiryForm = __webpack_require__(7625);
// EXTERNAL MODULE: ./src/store/CoreSlice.ts
var CoreSlice = __webpack_require__(1266);
// EXTERNAL MODULE: ./src/validations/Enquiry.ts
var Enquiry = __webpack_require__(6578);
// EXTERNAL MODULE: ./src/components/Layout/EnquirySuccess.tsx
var EnquirySuccess = __webpack_require__(6113);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/components/General/FileInput.tsx
var FileInput = __webpack_require__(9403);
// EXTERNAL MODULE: ./src/components/General/TextArea.tsx
var TextArea = __webpack_require__(6965);
// EXTERNAL MODULE: ./src/components/General/DatePicker.tsx
var DatePicker = __webpack_require__(4085);
;// CONCATENATED MODULE: ./src/components/Home/Enquiry.tsx

function Enquiry_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-radius : 4px;\n	width : 35px;\n	height : 35px;\n	background : transparent;\n	color : #384C9A;\n"
    ]);
    Enquiry_templateObject = function() {
        return data;
    };
    return data;
}


















const StyledQuantitySuffix = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e973600e-0"
})(Enquiry_templateObject());
function Enquiry_Enquiry(param) {
    let { firstHeading , secondHeading , subText  } = param;
    let initialValues = {
        // Autocomplete fields
        product_string: "",
        country_string: "",
        // Main fields
        product: null,
        product_text: "",
        quantity: null,
        price: null,
        expected_date: null,
        unit: 1,
        message: "",
        required_manufacturer: "",
        shipping_terms: "",
        // selected fields
        expected_certificates: [],
        pharmacopoeia_grades: []
    };
    const [showProductResults, setShowProductResults] = (0,react.useState)(false);
    const [showCountryResults, setShowCountryResults] = (0,react.useState)(false);
    const [productString, setProductString] = (0,react.useState)("");
    const [countryString, setCountryString] = (0,react.useState)("");
    const [casNumber, setCasNumber] = (0,react.useState)("");
    const [showEnquiryModal, setShowEnquiryModal] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { values , errors , touched , handleBlur , handleChange , handleSubmit , resetForm , setFieldValue  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: Enquiry/* default */.ZP,
        onSubmit: (values)=>{
            const payload = {
                ...values
            };
            payload["attachment"] = files.length ? files[0].id : null;
            // In case a Product String is there but not selected any predefined product.
            if (payload.product_string !== "" && payload.product === null) {
                payload.product_text = payload.product_string;
                setFieldValue("product_text", payload.product_string);
            }
            if (user.isLoggedIn) {
                dispatch((0,CoreSlice/* submitEnquiry */.yW)(payload));
            } else {
                dispatch((0,CoreSlice/* openEnquiryModal */.Qy)(payload));
                setShowEnquiryModal(true);
            }
        }
    });
    const { apiList , countryList , certificateList , pharmacopoeiaGradesList , enquiryState , files  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    (0,react.useEffect)(()=>{
        dispatch((0,CoreSlice/* getCertificateList */.DC)());
        dispatch((0,CoreSlice/* getPharmacopoeiaGrades */.z8)());
    }, []);
    (0,react.useEffect)(()=>{
        if (enquiryState.showSuccessModal) {
            resetEnquiryForm();
        }
    }, [
        enquiryState.showSuccessModal
    ]);
    // FUNCTIONS
    const handleProductSearch = (event)=>{
        setProductString(()=>event.target.value);
        setFieldValue("product_string", event.target.value);
        setShowProductResults(true);
        const params = {
            page: 1,
            page_size: 5,
            search: event.target.value
        };
        dispatch((0,CoreSlice/* getAPIList */.u8)(params));
        if (event.target.value == "") setFieldValue("product", null);
    };
    const selectProduct = (data)=>{
        setProductString(()=>data.name);
        setCasNumber(()=>data.cas_number);
        setFieldValue("product_string", data.name);
        setFieldValue("product", data.id);
        setShowProductResults(false);
    };
    const handleProductClear = ()=>{
        setProductString(()=>"");
        setFieldValue("product_string", "");
        setFieldValue("product", null);
        setCasNumber(()=>"");
    };
    const handleCountrySearch = (event)=>{
        setCountryString(()=>event.target.value);
        setFieldValue("country_string", event.target.value);
        setShowCountryResults(()=>true);
        const params = {
            search: event.target.value
        };
        dispatch((0,CoreSlice/* getCountryList */.Jp)(params));
        if (event.target.value == "") setFieldValue("country", null);
    };
    const selectCountry = (data)=>{
        setCountryString(()=>data.name);
        setFieldValue("country_string", data.name);
        setFieldValue("country", data.id);
        setShowCountryResults(()=>false);
    };
    const handleCountryClear = ()=>{
        setCountryString(()=>"");
        values.country_string = "";
        setFieldValue("country_string", "");
        setFieldValue("country", null);
    };
    const resetEnquiryForm = ()=>{
        resetForm();
        setProductString("");
        setCountryString("");
        dispatch((0,CoreSlice/* setFileData */.$C)({
            data: [],
            action: "replace"
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "enquiry-section",
                className: "pb-10 min-h-[300px] relative lg:flex justify-between items-center --align overflow-x-hidden py-[40px] lg:py-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "hidden md:inline-block absolute top-[80px] -left-[60px] z-0",
                        src: "/Home/Ellipse.svg",
                        width: 300,
                        height: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "hidden md:inline-block absolute bottom-[100px] -right-[100px] -z-9",
                        src: "/Home/Ellipse.svg",
                        width: 300,
                        height: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-theme-dark-saffron text-left mb-8 lg:w-[40%] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-3xl font-semibold -mb-4 lg:-mb-0 md:text-2xl lg:text-[2.9rem]",
                                children: [
                                    " ",
                                    firstHeading,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-3xl font-semibold pt-5 md:text-2xl lg:text-[2.9rem] mb-3",
                                children: [
                                    " ",
                                    secondHeading,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-sm lg:text-xl text-theme-blue",
                                children: [
                                    " ",
                                    subText,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm lg:text-lg mt-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex mb-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/Home/Call.svg",
                                                alt: "",
                                                className: "w-[29px] h-[29px] mr-[9px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-theme-dark-saffron",
                                                children: "+91-8655735634"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/Home/Email.svg",
                                                alt: "",
                                                className: "w-[29px] h-[29px] mr-[9px]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-theme-dark-saffron",
                                                children: "support@apidrug.com"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        id: "enquiry-form",
                        onSubmit: handleSubmit,
                        className: "\n                                relative \n                                z-1 \n                                bg-[#FEF7F5] \n                                grid \n                                grid-cols-1 \n								rounded-[5px]\n                                gap-4 \n                                md:grid-cols-2 \n                                lg:grid-cols-4\n                                gap-y-4\n								p-5\n                                lg:p-[30px]\n                                lg:w-[70%]\n                            ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "lg:col-span-2 relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        label: "Product",
                                        labelColor: "#305399",
                                        placeholder: "eg. Paracetamol",
                                        search: true,
                                        name: "product_string",
                                        onInput: handleProductSearch,
                                        value: productString,
                                        background: "#FEF7F5",
                                        color: "#314783",
                                        outerProperties: "rounded ".concat(!productString && "py-[11.5px]", " border border-[#0000001a]"),
                                        error: errors.product_string,
                                        touched: touched.product_string,
                                        onBlur: (e)=>{
                                            setTimeout(()=>{
                                                setShowProductResults(()=>false);
                                                handleBlur(e);
                                            }, 300);
                                        },
                                        searchResults: showProductResults && apiList.list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                                onClick: ()=>selectProduct(data),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "flex flex-col font-light",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                data.name,
                                                                " (",
                                                                data.cas_number,
                                                                ")"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                            children: [
                                                                " ",
                                                                data.product_type,
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index)),
                                        suffix: productString && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: handleProductClear,
                                            className: "cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-6 h-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M6 18L18 6M6 6l12 12"
                                                })
                                            })
                                        })
                                    }),
                                    casNumber ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                        className: "text-[#9ca3af] inline-block mt-2 opacity-70",
                                        children: [
                                            " CAS # ",
                                            casNumber,
                                            " "
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        className: "text-[#9ca3af] inline-block mt-2 opacity-70",
                                        children: " CAS # will be auto populated "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full ml-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    className: "mb-3",
                                    label: "Quantity",
                                    labelColor: "#305399",
                                    placeholder: "eg. 10",
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    outerProperties: "rounded py-0.5 border border-[#0000001a]",
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                        className: "text-white bg-theme-blue m-1 text-sm flex justify-center items-center",
                                        children: "KG"
                                    }),
                                    onChange: handleChange,
                                    name: "quantity",
                                    value: values.quantity,
                                    onBlur: handleBlur,
                                    error: errors.quantity,
                                    touched: touched.quantity
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                className: "mb-3",
                                label: "Target Price",
                                labelColor: "#305399",
                                placeholder: "eg. 220",
                                background: "#FEF7F5",
                                color: "#314783",
                                outerProperties: "rounded py-0.5 border border-[#0000001a]",
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                    className: "text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                    children: "$"
                                }),
                                onChange: handleChange,
                                name: "price",
                                value: values.price,
                                onBlur: handleBlur,
                                error: errors.price,
                                touched: touched.price
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    label: "Target Market",
                                    labelColor: "#305399",
                                    placeholder: "eg. USA",
                                    search: true,
                                    name: "country_string",
                                    onInput: handleCountrySearch,
                                    value: countryString,
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    outerProperties: "rounded ".concat(!countryString && "py-[11.5px]", " border border-[#0000001a]"),
                                    error: errors.country_string,
                                    touched: touched.country_string,
                                    onBlur: (e)=>{
                                        setTimeout(()=>{
                                            setShowCountryResults(()=>false);
                                            handleBlur(e);
                                        }, 300);
                                    },
                                    searchResults: showCountryResults && countryList.list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                            onClick: ()=>selectCountry(data),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "flex flex-col font-light",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: data.name
                                                })
                                            })
                                        }, index)),
                                    suffix: countryString && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: handleCountryClear,
                                        className: "cursor-pointer text-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-6 h-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker/* default */.Z, {
                                className: "mb-3",
                                label: "Delivery Date",
                                labelColor: "#305399",
                                background: "#FEF7F5",
                                color: "#314783",
                                minimumDate: new Date(),
                                outerProperties: "rounded py-0.5 border border-[#0000001a]",
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                    className: "text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        strokeWidth: 1.5,
                                        stroke: "currentColor",
                                        className: "w-6 h-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                                        })
                                    })
                                }),
                                name: "expected_date",
                                value: values.expected_date && (0,format["default"])(values.expected_date, "dd/MM/yyyy"),
                                onBlur: handleBlur,
                                error: errors.expected_date,
                                touched: touched.expected_date,
                                initialValue: values.expected_date,
                                onChange: (date)=>setFieldValue("expected_date", date)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                className: "mb-3",
                                label: "Required Manufacturer",
                                labelColor: "#305399",
                                background: "#FEF7F5",
                                color: "#314783",
                                outerProperties: "rounded py-[11px] border border-[#0000001a]",
                                onChange: handleChange,
                                name: "required_manufacturer",
                                value: values.required_manufacturer,
                                onBlur: handleBlur,
                                error: errors.required_manufacturer,
                                touched: touched.required_manufacturer
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "inline-block mb-1 text-[#305399]",
                                        children: " Certificates "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                        search: true,
                                        color: "#314783",
                                        placeholder: "eg. GMP, DMF",
                                        background: "#FEF7F5",
                                        additionalStyles: {
                                            border: "",
                                            padding: "2px 0"
                                        },
                                        multi: true,
                                        suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                            className: "text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-6 h-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                                })
                                            })
                                        }),
                                        items: certificateList.list,
                                        onChange: (selected)=>setFieldValue("expected_certificates", selected),
                                        error: errors.expected_certificates,
                                        placeholderStyles: {
                                            fontSize: 13,
                                            fontWeight: 300
                                        },
                                        name: "expected_certificates",
                                        value: values.expected_certificates,
                                        touched: touched.expected_certificates
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "inline-block mb-1 text-[#305399]",
                                        children: " Pharmacopoeia Grades "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                        search: true,
                                        color: "#314783",
                                        placeholder: "eg. USP, IP",
                                        background: "#FEF7F5",
                                        additionalStyles: {
                                            border: "",
                                            padding: "2px 0"
                                        },
                                        multi: true,
                                        suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                            className: "text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                fill: "none",
                                                viewBox: "0 0 24 24",
                                                strokeWidth: 1.5,
                                                stroke: "currentColor",
                                                className: "w-6 h-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                                })
                                            })
                                        }),
                                        items: pharmacopoeiaGradesList.list,
                                        onChange: (selected)=>setFieldValue("pharmacopoeia_grades", selected),
                                        placeholderStyles: {
                                            fontSize: 13,
                                            fontWeight: 300
                                        },
                                        name: "pharmacopoeia_grades",
                                        value: values.pharmacopoeia_grades,
                                        error: errors.pharmacopoeia_grades,
                                        touched: touched.pharmacopoeia_grades
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "inline-block mb-1 text-[#305399]",
                                        children: " Attach a file "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* default */.Z, {
                                        name: "attachment",
                                        uniqueID: "enquiry__attachment",
                                        disabled: files.length,
                                        error: errors.attachment,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "border border-[#0000001a] flex justify-between items-center bg-[#FEF7F5] py-[2px] rounded text-sm font-light pl-2 text-[gray]",
                                            children: [
                                                files.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Browse"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "flex",
                                                    children: [
                                                        files.length && helpers/* default.reduceStringLength */.Z.reduceStringLength(files[0].name),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                            onClick: ()=>dispatch((0,CoreSlice/* deleteFile */._I)(files[0].id)),
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            fill: "none",
                                                            viewBox: "0 0 24 24",
                                                            strokeWidth: 1.5,
                                                            stroke: "currentColor",
                                                            className: "w-5 h-5 ml-2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                d: "M6 18L18 6M6 6l12 12"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledQuantitySuffix, {
                                                    className: "text-white bg-theme-blue p-2 m-1 text-sm flex justify-center items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        strokeWidth: 1.5,
                                                        stroke: "currentColor",
                                                        className: "w-6 h-6",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            d: "M12 6v12m6-6H6"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    className: "mb-3",
                                    label: "Shipping Terms",
                                    labelColor: "#305399",
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    placeholder: "Enter Shipping terms",
                                    outerProperties: "rounded py-[11px] border border-[#0000001a]",
                                    onChange: handleChange,
                                    name: "shipping_terms",
                                    value: values.shipping_terms,
                                    onBlur: handleBlur,
                                    error: errors.shipping_terms,
                                    touched: touched.shipping_terms
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                    outerProperties: "w-full mt-3 pt-3 rounded placeholder:text-sm placeholder:font-light border border-[#0000001a]",
                                    rows: 4,
                                    background: "#FEF7F5",
                                    color: "#314783",
                                    placeholder: "Any Additional Comments?",
                                    onChange: handleChange,
                                    name: "message",
                                    value: values.message,
                                    onBlur: handleBlur
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                styles: "w-full text-white bg-theme-orange h-12 lg:w-[150px]",
                                destinationEvent: "",
                                children: "Submit"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquiryForm/* default */.Z, {
                show: showEnquiryModal,
                data: values,
                payload: values,
                countryList: countryList.fixedList,
                onClose: ()=>setShowEnquiryModal(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EnquirySuccess/* default */.Z, {
                show: enquiryState.showSuccessModal,
                user: enquiryState.responseData ? enquiryState.responseData.user : ""
            })
        ]
    });
}
Enquiry_Enquiry.defaultProps = {
    firstHeading: "Didn't find what",
    secondHeading: "you're looking for?",
    subText: "Share your requirement with us and we will find the best deal for you"
};
/* harmony default export */ var Home_Enquiry = (Enquiry_Enquiry);

// EXTERNAL MODULE: ./src/components/Home/ShortEnquiry.tsx
var ShortEnquiry = __webpack_require__(9310);
;// CONCATENATED MODULE: ./src/components/Home/QuickDelivery.tsx


function QuickDelivery() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "quick-delivery",
        className: "py-10 lg:py-[95px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-theme-blue text-center font-[500] text-[28px] capitalize lg:text-[45px] --align",
                children: [
                    "Do you need",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-theme-orange",
                        children: " quick delivery "
                    }),
                    " of APIs at",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-theme-orange",
                        children: " affordable prices "
                    }),
                    "without compromising on",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-theme-orange",
                        children: " quality "
                    }),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: " bg-[#F7E6BB] text-theme-blue font-[500] text-center text-[24px] mt-[30px] rounded-[3px] md:inline-block md:px-[10px] lg:text-[22px] lg:mt-[22px] ",
                    children: "Your are in the right place..."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortEnquiry/* default */.Z, {
                firstHeading: "Share your",
                secondHeading: "requirement here",
                subText: "and we will find the best deal for you from 4000+ sellers"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[40px] md:flex md:justify-between md:items-center --align",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:w-[50%] lg:w-[43%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full md:w-full",
                            src: "/Home/QuickDelivery.svg",
                            alt: "QuickDelivery",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-[20px] md:w-[40%] lg:w-[48%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px]",
                                children: "Guaranteed And Consistent Supply"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                                children: "We understand how crucial a reliable supply of APIs is for you. We take our suppliers' stock visibility very seriously. Due to our large network, there’s high chance that you will find the API stock nearby. We even invest in inventory of frequently moving molecules. We free you, to focus on what you are good at - your business operations."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Home_QuickDelivery = (QuickDelivery);

;// CONCATENATED MODULE: ./src/components/Home/MarketBeats.tsx





function MarketBeats() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "market-beating-exclusive-price",
        className: "--align py-10 lg:py-[95px]",
        style: {
            background: "rgba(229, 233, 241, 0.4)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:flex md:flex-row-reverse md:justify-between md:items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:w-[50%] lg:w-[39%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full md:w-full",
                        src: "/Home/MarketBeating.svg",
                        alt: "QuickDelivery",
                        loading: "lazy"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[20px] md:w-[40%] lg:w-[48%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]",
                            children: "Market-Beating Exclusive Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                            children: "The unique demand aggregation model of APIdrug.com gives us high negotiating power. With strong supplier relationships, APIdrug sources the best prices and often holds inventory at different locations globally, for fast-moving molecules. That’s how we get you the best deals without compromising on product quality."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center mt-[34px] lg:justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: ()=>helpers/* default.scrollTo */.Z.scrollTo("enquiry-section", 140),
                                    className: "w-[48%] lg:w-[193px] lg:mr-[20px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        styles: "bg-white text-theme-orange border border-theme-orange w-full h-[42px] lg:h-[54px] font-[400] lg:text-[18px]",
                                        children: "Open Bulk Deals"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/spot-buying",
                                    className: "w-[48%] lg:w-[193px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        styles: "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]",
                                        children: "Open Spot Prices"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Home_MarketBeats = (MarketBeats);

;// CONCATENATED MODULE: ./src/components/Home/GlobalStandards.tsx


function GlobalStandards() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "global-standards",
        className: "--align py-10 lg:py-[95px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:flex md:justify-between md:items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:w-[50%] lg:w-[44%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full md:w-full",
                        src: "/Home/GlobalStandards.svg",
                        alt: "GlobalStandards",
                        loading: "lazy"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[20px] md:w-[40%] lg:w-[48%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]",
                            children: "Global Quality Standards"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                            children: "In today’s situation, one bad batch can cost you millions of dollars. And lose the trust of your precious customers. APIdrug, in partnership with SGS and Intertek, tests the products upfront in labs with global quality standards. We verify all documents provided by the suppliers. So that you NEVER have to worry about the quality and reliability of the products."
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Home_GlobalStandards = (GlobalStandards);

;// CONCATENATED MODULE: ./src/components/Home/AffordableFinancing.tsx





function AffordableFinancing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "affordable-financing",
        className: "--align py-10 lg:py-[95px]",
        style: {
            background: "rgba(253, 236, 229, 0.4)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:flex md:flex-row-reverse md:justify-between md:items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:w-[50%] lg:w-[39%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full md:w-full",
                        src: "/Home/AffordableFinancing.svg",
                        alt: "QuickDelivery",
                        loading: "lazy"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[20px] md:w-[40%] lg:w-[50%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]",
                            children: "Affordable Financing Options"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                            children: "APIdrug's global marketplace offers some of the cheapest financing options in the industry, enabling you to benefit from economies of scale. Our flexible payment terms help you manage cash flow and invest in business growth. Our fast and hassle-free financing process has helped thousands of customers worldwide to increase profitability. Choose APIdrug to access affordable financing options and stay ahead of the competition."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center mt-[34px] lg:justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: ()=>helpers/* default.scrollTo */.Z.scrollTo("enquiry-section", 140),
                                    className: "w-[48%] lg:w-[193px] lg:mr-[20px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        styles: "bg-white text-theme-orange border border-theme-orange w-full h-[42px] lg:h-[54px] font-[400] lg:text-[18px]",
                                        children: "Open Bulk Deals"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/spot-buying",
                                    className: "w-[48%] lg:w-[193px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        styles: "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]",
                                        children: "Open Spot Prices"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Home_AffordableFinancing = (AffordableFinancing);

;// CONCATENATED MODULE: ./src/components/Home/HowItWorks.tsx



function HowItWorks() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "how-it-works",
        className: "--align py-10 lg:py-[60px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-center text-[#13203E] text-[40px] font-[650] mb-[34px] lg:text-[52px]",
                children: "How It Works ?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:flex md:justify-between md:items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:w-[50%] lg:w-[52%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full md:w-full",
                            src: "/Home/HowItWorks.svg",
                            alt: "QuickDelivery",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-[20px] md:w-[40%] lg:w-[40%] relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600] relative z-[10]",
                                children: "Spot Buying"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                                children: "View the latest spot prices effortlessly, in real-time, on your screen! We will handle the logistics, financing, and fulfillment for you. Buy what you need, when you need it, and we'll take care of the rest. We'll source the best prices, negotiate with sellers, and proactively plan our procurement process so you can relax!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/spot-buying",
                                className: "w-[48%] lg:w-[193px] block mt-[32px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    styles: "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]",
                                    children: "Open Spot Prices"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "absolute -top-[45px] w-[98px] lg:w-[137px] h-[98px] lg:h-[137px] lg:-top-[66px] lg:-left-[120px] z-1",
                                src: "/Home/Ellipse.svg",
                                alt: "",
                                loading: "lazy"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Home_HowItWorks = (HowItWorks);

;// CONCATENATED MODULE: ./src/components/Home/BulkDeals.tsx



function BulkDeals() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "bulk-deals",
        className: "--align py-10 lg:py-[60px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:flex md:flex-row-reverse md:justify-between md:items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:w-[50%] lg:w-[52%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-full md:w-full",
                        src: "/Home/BulkDeals.svg",
                        alt: "BulkDeals",
                        loading: "lazy"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[20px] md:w-[40%] lg:w-[40%]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-dark-saffron text-[24px] font-semibold lg:text-[36px] font-[600]",
                            children: "Bulk Deals"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[#333333] font-[300] lg:font-[200] text-[14px] mt-3 lg:text-[20px]",
                            children: "With APIdrug, you have the power to access large group buying deals by joining other buyers who share your needs. This helps you save money by securing lower-than-market prices and hedging against future price changes. This service is especially helpful for proactive companies that plan their procurement ahead of time."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            onClick: ()=>helpers/* default.scrollTo */.Z.scrollTo("enquiry-section", 140),
                            className: "w-[48%] lg:w-[193px] block mt-[32px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                styles: "text-white bg-theme-orange w-full h-[42px] lg:h-[54px] font-[500] lg:text-[18px]",
                                children: "Open Bulk Deals"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var Home_BulkDeals = (BulkDeals);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/Home/index.tsx















function Home() {
    const intersectionOptions = (0,react.useMemo)(()=>{
        return {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };
    }, []);
    const direction = useScrollDirection();
    (0,react.useEffect)(()=>{
        const targets = [
            "quick-delivery",
            "market-beating-exclusive-price",
            "global-standards",
            "affordable-financing",
            "how-it-works",
            "bulk-deals",
            "enquiry-section",
            "faq-section",
            "blogs-section"
        ];
        const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
        targets.forEach((target)=>{
            const element = document.getElementById(target);
            if (element) observer.observe(element);
        });
    }, []);
    // FUNCTIONS
    const intersectionCallback = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const MixPanelData = {
                    scrollDirection: direction,
                    section: entry.target.id
                };
                MixPanel/* MixpanelTracking.getInstance */.n.getInstance().scrolled(MixPanelData);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "World's first online marketplace for active pharmaceutical ingredients. | APIdrug Platform"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Buy 5000+ active pharmaceutical ingredients at the best prices. Find quality-tested products, and reliable suppliers for free. \n					Check spot prices and group buying deals."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hero-section",
                id: "hero-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_QuickDelivery, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_MarketBeats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_GlobalStandards, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_AffordableFinancing, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_HowItWorks, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_BulkDeals, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Enquiry, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "faq-section",
                className: "live-deals --align",
                style: {
                    paddingTop: 50,
                    paddingBottom: 60,
                    minHeight: 696
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-[28px] lg:text-[48px] font-semibold text-theme-dark-saffron pb-[65px]",
                        children: "Frequently Asked Questions (FAQs)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {})
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SellerHome/HeroSection.tsx







function HeroSection_HeroSection() {
    const dispatch = (0,es/* useDispatch */.I0)();
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    const [showDrawer, setShowDrawer] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    // Handle Auth Modal
    const openDialog = function() {
        let ID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        dispatch((0,AuthSlice/* handleAuthModal */.eD)(true));
    // if(ID) 
    //     dispatch(setRedirectTo(`deals/${ID}`));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "--align mt-5 lg:h-[80vh]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[50%] md:w-[30%] lg:w-[190px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/logo.png",
                            alt: ""
                        })
                    }),
                    user.isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-theme-green font-semibold mr-4 hidden md:block",
                                    children: [
                                        "Hi, ",
                                        user.name || "User"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/dashboard",
                                    className: "font-semibold bg-theme-green text-white rounded mr-5 py-2 px-2 transition duration-200",
                                    children: "Dashboard"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: ()=>dispatch((0,AuthSlice/* handleAuthModal */.eD)(true)),
                        styles: "bg-theme-green text-white px-6 h-[45px]",
                        borderRadius: 39,
                        children: "Start Selling"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col-reverse mt-10 md:flex-row md:justify-between md:items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 md:w-[40%] lg:w-[50%]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-theme-blue text-3xl font-semibold lg:mb-4 lg:text-4xl",
                                children: "Sell APIs, Excipients & "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-theme-blue text-3xl font-semibold lg:mb-4 lg:text-4xl",
                                children: "Nutraceuticals To Small and Medium"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-theme-blue text-3xl font-semibold lg:text-4xl",
                                children: "Sized Formulators Globally"
                            }),
                            !user.isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: ()=>dispatch((0,AuthSlice/* handleAuthModal */.eD)(true)),
                                styles: "bg-theme-green text-white px-6 mt-5 lg:mt-10 h-[45px]",
                                borderRadius: 39,
                                children: "Start Selling"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:w-[55%] lg:w-[45%] lg:h-[65vh]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "w-full h-full",
                            src: "/SellerHome/HeroImage.png",
                            alt: ""
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var SellerHome_HeroSection = (HeroSection_HeroSection);

;// CONCATENATED MODULE: ./src/components/SellerHome/WhySell.tsx

function WhySell_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    background: rgb(188,198,228);\n    background: -moz-linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    background: -webkit-linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    background: linear-gradient(270deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcc6e4",endColorstr="#ffffff",GradientType=1);\n    padding-top : 10px !important;\n    padding-bottom : 10px !important;\n'
    ]);
    WhySell_templateObject = function() {
        return data;
    };
    return data;
}
function WhySell_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n    background: rgb(188,198,228);\n    background: -moz-linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    background: -webkit-linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    background: linear-gradient(90deg, rgba(188,198,228,1) 0%, rgba(255,255,255,1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#bcc6e4",endColorstr="#ffffff",GradientType=1);\n    padding-top : 10px !important;\n    padding-bottom : 10px !important;\n'
    ]);
    WhySell_templateObject1 = function() {
        return data;
    };
    return data;
}


const LeftGradientDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7852d20a-0"
})(WhySell_templateObject());
const RightGradientDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7852d20a-1"
})(WhySell_templateObject1());
function WhySell() {
    const content = [
        {
            image: "/SellerHome/GlobalMarketting.png",
            heading: "Global Marketing",
            description: "Reach verified buyers from around the world and expand your reach. We will market your products to buyers on your behalf and share direct inquiries with you. We will provide international regulatory, financing, and logistics support to you."
        },
        {
            image: "/SellerHome/Payments.png",
            heading: "Hassle-Free Payments",
            description: "Reach verified buyers from around the world and expand your reach. We will market your products to buyers on your behalf and share direct inquiries with you. We will provide international regulatory, financing, and logistics support to you."
        },
        {
            image: "/SellerHome/Sales.png",
            heading: "Making Sales Easier",
            description: "Group buying deals will help in booking advanced orders. A simple dashboard and one point of contact (apidrug.com) will improve the productivity of your sales team massively. At the same time also allows you to monitor the market response of your products and prices."
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "my-5 lg:pb-[80px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-theme-blue text-[27px] lg:mb-4 lg:text-4xl --align",
                children: " Why sell on apidrug.com ? "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "text-theme-blue font-light --align",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "underline underline-offset-2",
                        children: "APIdrug.com"
                    }),
                    " is free to register. List your products today to start receiving direct inquiries and market intelligence."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: content.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 md:flex items-center ".concat(index % 2 !== 0 && "md:flex-row-reverse"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "\n                                    w-[60%] \n                                    mx-auto ".concat(index % 2 === 0 ? "md:ml-[30px] lg:ml-[90px]" : "md:mr-[30px] lg:mr-[90px]", "\n                                    lg:w-[15%]\n                                "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "w-full",
                                    src: data.image,
                                    alt: "",
                                    style: {
                                        height: "inherit"
                                    }
                                })
                            }),
                            index % 2 === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftGradientDiv, {
                                className: "--align my-2 md:my-0 lg:w-[70%] lg:h-[190px] flex flex-col justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-[#243868] font-semibold text-xl mb-5",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-2xl",
                                                children: [
                                                    " ",
                                                    index + 1,
                                                    ". "
                                                ]
                                            }),
                                            " ",
                                            data.heading,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-light text-theme-blue",
                                        children: [
                                            " ",
                                            data.description,
                                            " "
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightGradientDiv, {
                                className: "--align my-2 md:my-0 lg:w-[70%] lg:h-[190px] flex flex-col justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-[#243868] font-semibold text-xl mb-5",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-2xl",
                                                children: [
                                                    " ",
                                                    index + 1,
                                                    ". "
                                                ]
                                            }),
                                            " ",
                                            data.heading,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-light text-theme-blue",
                                        children: [
                                            " ",
                                            data.description,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, index))
            })
        ]
    });
}
/* harmony default export */ var SellerHome_WhySell = (WhySell);

// EXTERNAL MODULE: ./src/components/title.tsx
var title = __webpack_require__(2868);
// EXTERNAL MODULE: ./src/validations/FixedPrice.ts
var FixedPrice = __webpack_require__(4034);
// EXTERNAL MODULE: ./src/utils/axios.ts + 41 modules
var axios = __webpack_require__(2644);
// EXTERNAL MODULE: ./src/constants/api-endpoints.ts
var api_endpoints = __webpack_require__(474);
// EXTERNAL MODULE: ./src/utils/access-token.js
var access_token = __webpack_require__(5276);
// EXTERNAL MODULE: ./src/components/EnquiryResponse/Success.tsx
var Success = __webpack_require__(7992);
// EXTERNAL MODULE: ./src/constants/MixPanelEvents.ts
var MixPanelEvents = __webpack_require__(4416);
;// CONCATENATED MODULE: ./src/components/SellerHome/ProductListing.tsx

function ProductListing_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color : rgba(255,255,255, 0.2)\n"
    ]);
    ProductListing_templateObject = function() {
        return data;
    };
    return data;
}



















const CirciledDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8dc076d4-0"
})(ProductListing_templateObject());
function ProductListing() {
    const initialValues = {
        "seller_product": {
            "product": null,
            "pharmacopoeia_grades": [],
            "certificates": [],
            "country": null
        },
        "product_search_string": "",
        "country_search_string": "",
        "price": null,
        "quantity_available": null,
        "minimum_order_quantity": null,
        "validity": null,
        "quantity_available_unit": 1,
        "minimum_order_quantity_unit": 1,
        "payment_terms": ""
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const { apiList: { list  } , certificateList , unitList , pharmacopoeiaGradesList , countryList  } = (0,es/* useSelector */.v9)((state)=>state.core);
    const { user  } = (0,es/* useSelector */.v9)((state)=>state.auth);
    let [countryString, setCountryString] = (0,react.useState)("");
    const [productString, setProductString] = (0,react.useState)("");
    const [showProductResult, setShowProductResult] = (0,react.useState)(()=>false);
    const [showCountryResults, setShowCountryResults] = (0,react.useState)(false);
    const [showSuccessModal, setShowSuccessModal] = (0,react.useState)(false);
    const [payload, setPayload] = (0,react.useState)({});
    const { values , errors , handleSubmit , handleChange , touched , handleBlur , resetForm , setFieldValue  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: FixedPrice/* default */.Z,
        onSubmit: (values, action)=>{
            delete values["product_search_string"];
            delete values["country_search_string"];
            if (user.isLoggedIn) submitForm(values);
            else {
                setPayload((previousValue)=>{
                    return {
                        ...previousValue,
                        ...values
                    };
                });
                dispatch((0,AuthSlice/* handleAuthModal */.eD)(true));
            }
        }
    });
    (0,react.useEffect)(()=>{
        dispatch((0,CoreSlice/* getCertificateList */.DC)());
        dispatch((0,CoreSlice/* getPharmacopoeiaGrades */.z8)());
        MixPanel/* MixpanelTracking.getInstance */.n.getInstance().pageViewed({});
    }, []);
    (0,react.useEffect)(()=>{
        if (user.isLoggedIn && Object.keys(payload).length !== 0) submitForm(payload);
    }, [
        user.isLoggedIn
    ]);
    // FUNCTIONS
    const handleProductSearch = (event)=>{
        setShowProductResult(()=>true);
        setProductString(()=>event.target.value);
        const params = {
            search: event.target.value,
            page: 1,
            page_size: 5
        };
        dispatch((0,CoreSlice/* getAPIList */.u8)(params));
    };
    const handleCountrySearch = (event)=>{
        setShowCountryResults(()=>true);
        setCountryString(()=>event.target.value);
        const params = {
            search: event.target.value,
            page: 1,
            page_size: 5
        };
        dispatch((0,CoreSlice/* getCountryList */.Jp)(params));
    };
    const selectProduct = (item)=>{
        setProductString(()=>item.name);
        setFieldValue("seller_product.product", item.id);
        setShowProductResult(()=>false);
    };
    const selectCountry = (item)=>{
        setCountryString(()=>item.name);
        setFieldValue("seller_product.country", item.id);
        setShowCountryResults(()=>false);
    };
    const handleProductClear = ()=>{
        setProductString("");
        setFieldValue("seller_product.product", null);
        setFieldValue("product_search_string", "");
    };
    const handleCountryClear = ()=>{
        setCountryString("");
        setFieldValue("country_search_string", "");
    };
    const submitForm = (payload)=>{
        const data = {
            ...payload
        };
        // Converting to array of ids
        data["seller_product"]["certificates"] = data["seller_product"]["certificates"].map((certificate)=>certificate.id);
        data["seller_product"]["pharmacopoeia_grades"] = data["seller_product"]["pharmacopoeia_grades"].map((grade)=>grade.id);
        const mixPanelData = {
            form: "List Your Product",
            userInput: data
        };
        const endPoint = helpers/* default.getAPIEndpoint */.Z.getAPIEndpoint(api_endpoints/* default.fixedPrice */.Z.fixedPrice);
        const headers = {
            Authorization: "Bearer ".concat(access_token/* default.getAccessToken */.Z.getAccessToken())
        };
        const successHandler = (response)=>{
            if (response.status === 201) {
                const emptyObject = {};
                setShowSuccessModal(true);
                setProductString("");
                setCountryString("");
                resetForm();
                setPayload(emptyObject);
                mixPanelData["status"] = MixPanelEvents/* MixPanelConstants.SUCCESS */.f.SUCCESS;
                MixPanel/* MixpanelTracking.getInstance */.n.getInstance().formSubmitted(mixPanelData);
            }
        };
        const errorHandler = (error)=>{
            console.log(error);
            const message = error.response.data.detail || "Something went wrong internally!";
            dispatch((0,ToastSlice/* setSnackBar */.c6)({
                color: "error",
                message: message
            }));
            mixPanelData["status"] = MixPanelEvents/* MixPanelConstants.FAILED */.f.FAILED;
            mixPanelData["reason"] = message;
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().formSubmitted(mixPanelData);
        };
        axios/* default.requestPOST */.Z.requestPOST(endPoint, data, headers, successHandler, errorHandler);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-[#324D9F] --align",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-10 lg:flex lg:justify-between lg:py-[100px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "text-white text-2xl py-7 lg:text-6xl lg:w-[30%] capitalize relative",
                        children: [
                            "List your first product. It’s free!",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CirciledDiv, {
                                className: "hidden lg:block w-[120px] h-[120px] rounded-[50%] absolute bottom-[170px] left-[50px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "my-2 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 lg:w-[65%] lg:gap-y-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-2 relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "Select Product",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    name: "product_search_string",
                                    value: productString,
                                    onBlur: handleBlur,
                                    error: errors.product_search_string,
                                    touched: touched.product_search_string,
                                    onChange: handleChange,
                                    onInput: handleProductSearch,
                                    suffix: productString ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: handleProductClear,
                                        className: "cursor-pointer text-sm flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-4 h-4 text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-4 h-4 text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                            })
                                        })
                                    }),
                                    search: true,
                                    searchResults: showProductResult && list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                            onClick: ()=>selectProduct(data),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "flex flex-col font-light",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            data.name,
                                                            " (",
                                                            data.cas_number,
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                        children: [
                                                            " ",
                                                            data.product_type,
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, index))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "Country of Manufacturing",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    value: countryString,
                                    search: true,
                                    error: errors.country,
                                    touched: errors.country,
                                    onChange: handleChange,
                                    onInput: handleCountrySearch,
                                    onBlur: ()=>{
                                        setTimeout(()=>{
                                            setShowCountryResults(false);
                                        }, 300);
                                    },
                                    searchResults: showCountryResults && countryList.list.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: " flex justify-between text-[12px] my-1 py-2 text-theme-black font-light cursor-pointer rounded items-center hover:bg-[#D4D9E7]/50 font-semibold",
                                            onClick: ()=>selectCountry(data),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "flex flex-col font-light",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: data.name
                                                })
                                            })
                                        }, index)),
                                    suffix: countryString ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: handleCountryClear,
                                        className: "cursor-pointer text-sm flex justify-center items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-4 h-4 text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M6 18L18 6M6 6l12 12"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            strokeWidth: 1.5,
                                            stroke: "currentColor",
                                            className: "w-4 h-4 text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                d: "M19.5 8.25l-7.5 7.5-7.5-7.5"
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    placeholder: "Quality (Multi-select)",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    additionalStyles: {
                                        padding: "2px 0"
                                    },
                                    multi: true,
                                    items: certificateList.list,
                                    onChange: (selected)=>setFieldValue("seller_product.certificates", selected),
                                    value: values.seller_product.certificates,
                                    placeholderStyles: {
                                        fontSize: 13,
                                        fontWeight: 300,
                                        color: "white"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    placeholder: "Pharmacopeia (Single-select)",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    additionalStyles: {
                                        padding: "2px 0"
                                    },
                                    items: pharmacopoeiaGradesList.list,
                                    onChange: (selected)=>setFieldValue("seller_product.pharmacopoeia_grades", [
                                            selected
                                        ]),
                                    value: values.seller_product.pharmacopoeia_grades,
                                    placeholderStyles: {
                                        fontSize: 13,
                                        fontWeight: 300,
                                        color: "white"
                                    },
                                    valueColor: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "Qty available",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    name: "quantity_available",
                                    value: values.quantity_available,
                                    onBlur: handleBlur,
                                    error: errors.quantity_available,
                                    touched: touched.quantity_available,
                                    onChange: handleChange,
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white",
                                        children: " KG "
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "Price per KG",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    name: "price",
                                    value: values.price,
                                    onBlur: handleBlur,
                                    error: errors.price,
                                    touched: touched.price,
                                    onChange: handleChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "MOQ",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    name: "minimum_order_quantity",
                                    value: values.minimum_order_quantity,
                                    onBlur: handleBlur,
                                    error: errors.minimum_order_quantity,
                                    touched: touched.minimum_order_quantity,
                                    onChange: handleChange,
                                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-white",
                                        children: " KG "
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:col-span-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    placeholder: "Payment terms valid till",
                                    background: "transparent",
                                    color: "white",
                                    outerProperties: "border border-slate-400 border-[0.5px] rounded py-2 px-2",
                                    properties: "placeholder:text-white",
                                    name: "payment_terms",
                                    value: values.payment_terms,
                                    onBlur: handleBlur,
                                    error: errors.payment_terms,
                                    touched: touched.payment_terms,
                                    onChange: handleChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-3 mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    styles: "bg-theme-green text-white px-6 h-[45px] w-full md:w-[200px] lg:py-7",
                                    borderRadius: 39,
                                    destinationEvent: "",
                                    children: "Submit"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Success/* default */.Z, {
                show: showSuccessModal,
                onClose: ()=>setShowSuccessModal(false)
            })
        ]
    });
}
/* harmony default export */ var SellerHome_ProductListing = (ProductListing);

;// CONCATENATED MODULE: ./src/components/SellerHome/index.tsx






function Seller() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                title: "Seller"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerHome_HeroSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerHome_WhySell, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerHome_ProductListing, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "live-deals --align",
                        style: {
                            paddingTop: 50,
                            paddingBottom: 60,
                            minHeight: 696
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl text-theme-blue pb-[30px] lg:text-4xl",
                                children: "Frequently Asked Questions (FAQs)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQs/* default */.Z, {})
                        ]
                    })
                ]
            })
        ]
    });
}
Seller.SellerLayout = (page)=>{
    return {
        page
    };
};
/* harmony default export */ var SellerHome = (Seller);

;// CONCATENATED MODULE: ./src/validations/PortalLogin.ts

const PortalLogin = yup_es/* object */.Ry({
    email: yup_es/* string */.Z_().email().required("Email is required!"),
    password: yup_es/* string */.Z_().required("Password is required!")
});
/* harmony default export */ var validations_PortalLogin = (PortalLogin);

;// CONCATENATED MODULE: ./src/components/LoginComponent.tsx






function LoginComponent(props) {
    const initialValues = {
        email: "",
        password: "",
        user_type: "seller"
    };
    const [buttonLoader, setButtonLoader] = (0,react.useState)(false);
    const { values , errors , handleSubmit , handleBlur , handleChange , touched , resetForm  } = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: validations_PortalLogin,
        onSubmit: (values, action)=>{
            props.onLogin(values, action.resetForm, setButtonLoader);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            background: "#F7F7F7"
        },
        className: "h-[100vh] flex items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inputs bg-white p-[50px] w-[100%] md:w-[50%] lg:w-[30%] rounded drop-shadow-xl shadow-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "logo flex items-center justify-between mb-10 gap-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/logo.png",
                            alt: "",
                            className: "w-[30%] lg:w-[40%]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-3xl border-l-2 border-theme-black pl-2",
                            children: props.portalHeading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inputs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    label: "Email",
                                    labelColor: "#444444",
                                    labelProperties: "opacity-50 text-[15px]",
                                    placeholder: "Enter Email",
                                    properties: "border border-[#707070 50%] rounded h-11 placeholder:text-sm",
                                    onChange: handleChange,
                                    name: "email",
                                    value: values.email,
                                    onBlur: handleBlur,
                                    error: errors.email,
                                    touched: touched.email,
                                    type: "email"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                    label: "password",
                                    labelColor: "#444444",
                                    labelProperties: "opacity-50 text-[15px]",
                                    placeholder: "Enter Password",
                                    properties: "border border-[#707070 50%] rounded h-11 placeholder:text-sm",
                                    onChange: handleChange,
                                    name: "password",
                                    value: values.password,
                                    onBlur: handleBlur,
                                    error: errors.password,
                                    touched: touched.password,
                                    type: "password"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                styles: "bg-theme-orange text-white w-full mt-10 h-12",
                                loader: buttonLoader,
                                children: "Login"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
LoginComponent.SellerLayout = (page)=>page;
/* harmony default export */ var components_LoginComponent = (LoginComponent);

;// CONCATENATED MODULE: ./src/components/AdminHome/index.tsx












function AdminHome() {
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const handleLogin = (values, resetForm, setButtonLoader)=>{
        const endPoint = helpers/* default.getAPIEndpoint */.Z.getAPIEndpoint(api_endpoints/* default.staffLogin */.Z.staffLogin);
        const mixPanelData = {
            action: MixPanelEvents/* MixPanelConstants.LOGGED_IN */.f.LOGGED_IN,
            actionType: MixPanelEvents/* MixPanelConstants.STANDARD */.f.STANDARD
        };
        setButtonLoader(true);
        const successHandler = (response)=>{
            const userDetails = helpers/* default.decodeToken */.Z.decodeToken(response.data.access);
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().identifyUser(userDetails.email);
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().authFinished({
                ...mixPanelData,
                status: MixPanelEvents/* MixPanelConstants.SUCCESS */.f.SUCCESS
            });
            setButtonLoader(false);
            if (response.status === 200) {
                access_token/* default.setCredentials */.Z.setCredentials(response.data.access, response.data.refresh, response.data.name);
                dispatch((0,AuthSlice/* setUserDetails */.XN)({
                    isLoggedIn: true,
                    name: response.data.name
                }));
                router.push("/support/chat");
                dispatch((0,ToastSlice/* setSnackBar */.c6)({
                    color: "success",
                    message: "You have successfully signed in!"
                }));
                resetForm();
            }
        };
        const errorHandler = (error)=>{
            console.log(error.response.data);
            setButtonLoader(false);
            let message = "";
            try {
                message = error.response.data.message[0];
            } catch (e) {
                message = error.response.data.detail;
            }
            dispatch((0,ToastSlice/* setSnackBar */.c6)({
                color: "error",
                message: message
            }));
            MixPanel/* MixpanelTracking.getInstance */.n.getInstance().authFinished({
                ...mixPanelData,
                status: MixPanelEvents/* MixPanelConstants.FAILED */.f.FAILED
            });
        };
        axios/* default.requestPOST */.Z.requestPOST(endPoint, values, {}, successHandler, errorHandler);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoginComponent, {
        portalHeading: "Admin Portal",
        onLogin: handleLogin
    });
}
/* harmony default export */ var components_AdminHome = (AdminHome);

;// CONCATENATED MODULE: ./src/pages/index.tsx








function pages_Home(param) {
    let { subdomain  } = param;
    const SELLER_SUBDOMAIN_NAME = "seller";
    const ADMIN_SUBDOMAIN_NAME = "admin";
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        MixPanel/* MixpanelTracking.getInstance */.n.getInstance().pageViewed({});
        if (subdomain === SELLER_SUBDOMAIN_NAME) {
            dispatch((0,CoreSlice/* setIsAdminSubdomain */.RV)(false));
            dispatch((0,CoreSlice/* setIsSellerSubdomain */.Vl)(true));
        } else if (subdomain === ADMIN_SUBDOMAIN_NAME) {
            dispatch((0,CoreSlice/* setIsAdminSubdomain */.RV)(true));
            dispatch((0,CoreSlice/* setIsSellerSubdomain */.Vl)(false));
        } else {
            dispatch((0,CoreSlice/* setIsAdminSubdomain */.RV)(false));
            dispatch((0,CoreSlice/* setIsSellerSubdomain */.Vl)(false));
        }
    }, []);
    if (subdomain === SELLER_SUBDOMAIN_NAME) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SellerHome, {});
    else if (subdomain === ADMIN_SUBDOMAIN_NAME) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AdminHome, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {});
}
var __N_SSP = true;
/* harmony default export */ var pages = (pages_Home);


/***/ }),

/***/ 4034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4231);

const FixedPriceSchema = yup__WEBPACK_IMPORTED_MODULE_0__/* .object */ .Ry({
    product_search_string: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("This field is required!"),
    price: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().nullable().required("This field is required!"),
    quantity_available: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("This field is required!").nullable().typeError("Please enter a valid quantity!"),
    minimum_order_quantity: yup__WEBPACK_IMPORTED_MODULE_0__/* .number */ .Rx().required("This field is required!").nullable().typeError("Please enter a valid price!")
});
/* harmony default export */ __webpack_exports__["Z"] = (FixedPriceSchema);


/***/ }),

/***/ 4621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"hero-section_heroContainer__IqGAn","backgroundContainer":"hero-section_backgroundContainer__eDv41","search":"hero-section_search__WTe5K","logo":"hero-section_logo__F6kyu","burger":"hero-section_burger___0608","getInTouch":"hero-section_getInTouch__TmtLW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [334,198,946,423,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);